<template>
  <v-row no-gutters class="sideBySideToolbar secondary">
    <v-col cols="auto" class="d-flex align-center mr-auto">
      <span class="current-image-eye" :class="colorClass">{{sideBySideLeftEye}}</span>
    </v-col>
    <v-col cols="auto" class="d-flex align-center ml-auto">
      <image-button
        btnClass="toggleAnnotation ml-auto"
        title="Annotation Bar"
        :small="ieButton"
        :image="coloredAssetUrls.annotate"
        @click="toggleSideBySideAnnotation"/>
      <span class="current-image-eye" :class="colorClass">{{sideBySideRightEye}}</span>
    </v-col>
  </v-row>
</template>

<script>
import imageButton from "../controls/ImageButton";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "sideBySideEyeBar",
  components: {imageButton},
  computed: {
    ...mapGetters(["sideBySideLeftEye", "sideBySideRightEye", "isIE"]),
    ieButton() {
      if (this.isIE)
        return true;
      return false;
    }
  },
  methods: {
    ...mapMutations(["toggleSideBySideAnnotation"]),
  }
}
</script>